import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  Typography,
  Box,
  Snackbar,
  Alert
} from "@mui/material";

const whatsappTemplates = [
  {
    id: 1,
    name: "Invitation",
    message: "Hi {candidate_first_name}! {company_name} invites you to a video interview. \n\nWe just sent you an email with the instructions and the interview link. (If you can’t find it, please check the spam folder in case it was misplaced.)\n\nThank you!",
  },
  {
    id: 2,
    name: "Reminder",
    message: "Hello {candidate_first_name}, just a reminder that your interview with {company_name} is scheduled for tomorrow. \n\nPlease make sure to be prepared. Let us know if you have any questions. \n\nThanks!",
  },
];

const WhatsAppTemplateModal = ({ open, onClose, templateData, refreshTemplates }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState(whatsappTemplates[0]);

  useEffect(() => {
    if (templateData) {
      const foundTemplate = whatsappTemplates.find(t => t.name === templateData.type);
      if (foundTemplate) {
        setSelectedTemplate({ ...foundTemplate, message: templateData.wa_content });
      }
    }
  }, [templateData]);
  const handleCreateTemplate = async () => {
    const payload = {
      wa_template_id: templateData?.id,
      type: selectedTemplate.name,
      wa_content: selectedTemplate.message
    };


    try {
      const response = await fetch(templateData ? `https://api.a2ajobs.com/api/wa-template-update` : "https://api.a2ajobs.com/api/wa-template-create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setSnackbarMessage(`WhatsApp Template ${templateData ? "Updated" : "Saved"} Successfully!`);
        setSnackbarOpen(true);
        onClose();
      } else {
        console.error("Failed to create template");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };


  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Select a base template</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 1 }}>Template</Typography>
        <Select
          fullWidth
          value={selectedTemplate.id}
          onChange={(e) =>
            setSelectedTemplate(whatsappTemplates.find(t => t.id === e.target.value))
          }
        >
          {whatsappTemplates.map((template) => (
            <MenuItem key={template.id} value={template.id}>
              {template.name}
            </MenuItem>
          ))}
        </Select>

        <Box className="mt-4 flex justify-center">
          <Box className="w-64 border-4 border-black rounded-2xl p-3 bg-white">
            <Typography className="text-center text-xs font-bold">Aitutor</Typography>
            <Box className="mt-2 bg-gray-200 p-3 rounded-lg shadow">
              <Typography className="text-sm whitespace-pre-line">
                {selectedTemplate.message}
              </Typography>
            </Box>
          </Box>
        </Box>
      </DialogContent>

      {/* Create Template Button */}
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="primary" sx={{ textTransform: 'none' }} onClick={handleCreateTemplate}> {templateData ? "Update Template" : "Create Template"}</Button>
      </DialogActions>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => {
          setSnackbarOpen(false);
        }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity="success" variant="filled">
          {snackbarMessage}
        </Alert>
      </Snackbar>

    </Dialog>
  );
};

export default WhatsAppTemplateModal;
